import React from "react";
import { ComponentSectionsCodeEmbed } from "@/graphql/generated/graphql";

export function CodeEmbed({ code }: ComponentSectionsCodeEmbed): JSX.Element {
  if (!code) return <></>;
  return <div dangerouslySetInnerHTML={{ __html: code }} />;
}
